export const ROLE_LABELS: Record<string, string> = { admin: 'Admin', editor: 'Editor', viewer: 'Viewer' };
export const AVATAR_COLORS = ['#FF0000', '#FFFF00', '#58585B', '#757575', '#707070', '#B3B3B3', '#1A1A1C', '#F5F5F5'];

export function timeAgo(dateStr: string | null) {
  if (!dateStr) return 'Never';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}

export function formatDate(dateStr: string | null) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
}

export function actionLabel(action: string) {
  const labels: Record<string, string> = {
    login: 'Logged in',
    google_login: 'Google login',
    agent_google_login: 'Agent login',
    register: 'Registered',
    password_change: 'Changed password',
    role_change: 'Role changed',
    user_deactivate: 'User deactivated',
    user_reactivate: 'User reactivated',
    user_invite: 'Invited user',
    user_update: 'Profile updated',
    admin_password_reset: 'Password reset by admin',
    upload: 'Uploaded fonts',
    font_delete: 'Deleted font',
    activate: 'Activated font',
    deactivate: 'Deactivated font',
    tag_font: 'Tagged font',
    favorite: 'Favorited font',
    unfavorite: 'Unfavorited font',
  };
  return labels[action] || action;
}
